import React, { useEffect } from "react";
import ReportUtils from "../../../../../utils/report-utils.js";
import AttachmentContent from "./attachment-content.jsx";
import { navigateHook } from "../../../../../hooks/use-navigate.js";

const ReportContent = ({ data, showImages, tableColumns }) => {
  const navigate = navigateHook();

  useEffect(() => {
      ReportUtils.createExportableTable(null, null, "Avaria de veículos", "garrison-damage-data",);
  }, [data, tableColumns]);

    if (!data?.length) return null;

    const columns = [
        { id: "dateTime", className: "w-[20%]", render: (item) => item.dt_create },
        { id: "prefix", className: "w-[20%]", render: (item) => item.prefix },
        { id: "plate", className: "w-[20%]", render: (item) => (
            <a onClick={() => navigate(`/despacho/garrison/form/${item.garrison_id}`, true)} title="Ver guarnição" className="report-link">
              {item.plate}
            </a>
          ),
        },
        { id: "user", className: "w-[20%]", render: (item) => item.user },
        { id: "observation", className: "w-[20%]", render: (item) => item.observation ?? "" },
      ];

      const visibleColumns = columns.filter(
        (column) => tableColumns?.[column.id]?.visible !== false,
      );

  return (
    <>
      {visibleColumns.length ? (
          <table id="garrison-damage-data" className="report-table table" sheet-name="Avaria de veículos">
              <thead className="thead-background">
                  <tr className="text-left">
                      {visibleColumns.map((column) => (
                          <th key={column.id} className={column.className}>
                              {tableColumns[column.id].label}
                          </th>
                      ))}
                  </tr>
              </thead>
              <tbody>
                  {data.map((item, index) => (
                      <React.Fragment key={index}>
                            <tr className={showImages ? "details-row" : ""}>
                              {visibleColumns.map((column) => (
                                  <td key={column.id} className={column.className}>
                                      {column.render(item)}
                                  </td>
                              ))}
                          </tr>

                          {showImages && item.attachments?.length > 0 && (
                              <AttachmentContent element={item.attachments} colSpan={visibleColumns.length}/>
                          )}
                      </React.Fragment>
                  ))}
              </tbody>
          </table>
      ) : (
            <div id="noDataMessage" className="alert alert-info p-2 h6 text-center">
              Todas as colunas foram ocultadas.
          </div>
      )}

        <div id="chart-tables"/>
    </>
  );
};

export default ReportContent;